import { Component, Input } from '@angular/core';
import { Infringement } from '../../../intefaces/infringement.interface';

@Component({
  selector: 'app-infringement-details-ip-infringement',
  standalone: true,

  templateUrl: './infringement-details-ip-infringement.component.html',
  styleUrl: './infringement-details-ip-infringement.component.scss'
})
export class InfringementDetailsIpInfringementComponent {
    @Input()
    infringement!: Infringement;

}
